<!--
 * @Author: zql
 * @Date: 2020-03-13 15:29:14
 * @LastEditTime: 2020-06-02 14:32:54
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \enfry-components\packages\components\en-result\src\noFile\no-file.vue
-->
<template>
  <div
    ref="NoFile"
    class="nofile"
  >
    <img
      slot="icon"
      class="icon-img"
      src="http://cdn.enfry.com/no-file11331.png"
      :alt="this.title"
    >
    <div class="title" v-html="title"></div>
    <div class="subtitle" v-html="subTitle"></div>
  </div>
</template>

<script>
export default {
  name: "NoFile",
  props: {
    type: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    iconSize: {
      type: [String, Number],
      default: "normal"
    },
    title: {
      type: String,
      default: null
    },
    subTitle: {
      type: String,
      default: "暂无内容/文件"
    }
  }
}
</script>
<style lang="scss" scoped>
  .nofile {
    text-align: center;

    .icon-img {
      height: 78px;
      width: 120px;
    }
  }
</style>

